<template>
    <div class="animated fadeIn">
        <b-container>
            <b-row>
                <b-col>
                    <h2>Account</h2>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6">
                    <b-card>
                        <h4 class="mb-3">Profile</h4>
                        <b-form-group label="First Name" horizontal>
                            <b-input type="text" v-model="first_name" />
                        </b-form-group>
                        <b-form-group label="Last Name" horizontal>
                            <b-input type="text" v-model="last_name" />
                        </b-form-group>
                        <b-form-group label="Username/Email" horizontal>
                            <b-input type="email" v-model="email" disabled />
                        </b-form-group>

                        <div class="text-right">
                            <b-button variant="success" @click="updateUser">
                                <font-awesome-icon v-if="submitting == 'user'" icon="spinner" pulse />
                                Update
                            </b-button>
                        </div>

                        <h4 class="mb-3">Change Password</h4>
                        <b-form-group label="Password" horizontal>
                            <b-input type="password" v-model="password" />
                        </b-form-group>
                        <b-form-group label="Confirm" horizontal>
                            <b-input type="password" v-model="password_confirm" />
                        </b-form-group>

                        <div class="text-right">
                            <b-button variant="success" @click="updatePassword">
                                <font-awesome-icon v-if="submitting == 'password'" icon="spinner" pulse />
                                Change Password
                            </b-button>
                        </div>
                    </b-card>
                </b-col>

                <b-col md="6">
                    <b-card>
                        <h4 class="mb-3">Billing Address</h4>

                        <b-form-group label="Street 1" horizontal>
                            <b-input type="text" v-model="billing.street_1" :state="(typeof errors['billing.street_1'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{errors['billing.street_1']}}
                            </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group label="Street 2" horizontal>
                            <b-input type="text" v-model="billing.street_2" />
                        </b-form-group>

                        <b-form-group label="City" horizontal>
                            <b-input type="text" v-model="billing.city" :state="(typeof errors['billing.city'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{errors['billing.city']}}
                            </b-form-invalid-feedback>

                        </b-form-group>
                        <b-form-group label="State" horizontal>
                            <state-select v-model="billing.state" />
                        </b-form-group>

                        <b-form-group label="Zip Code" horizontal>
                            <b-input type="text" v-model="billing.postal_code" :state="(typeof errors['billing.postal_code'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback" />
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{errors['billing.postal_code']}}
                            </b-form-invalid-feedback>
                        </b-form-group>
                        
                        <b-form-group label="Country" horizontal>
                            <country-select v-model="billing.country" />
                        </b-form-group>
                        
                        <b-form-group label="Phone" horizontal>
                            <b-input type="text" v-model="billing.phone" />
                        </b-form-group>

                        <div class="text-right">
                            <b-button variant="success" @click="updateAddress">
                                <font-awesome-icon v-if="submitting == 'billing_address'" icon="spinner" pulse />
                                Update
                            </b-button>
                        </div>
                        
                    </b-card>
                </b-col>

            </b-row>

            <b-row v-if="false">
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col md="6">
                                <h4 class="mb-3">Account Users</h4>
                            </b-col>
                            <b-col md="6" class="text-right">
                                <b-button variant="success">Add User</b-button>
                            </b-col>
                        </b-row>

                        <b-table>

                        </b-table>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
  </div>
</template>
<script>
import CountrySelect from '../../components/CountrySelect'
import StateSelect from '../../components/StateSelect'
export default {
    name: 'Profile',
    components: { CountrySelect, StateSelect },
    data () {
        return {
            first_name: '',
            last_name: '',
            email: '',

            role_id: null,
            role_uuid: null,

            roles: [],

            perms: [],
            selectedPerms: [],
            billing: {
                first_name: '',
                last_name: '',
                street_1: '',
                street_2: '',
                city: '',
                state: '',
                postal_code: '',
                country: 'US',
                phone: ''
            },

            submitting: null,

            password: 'password',
            password_confirm: 'password',

            errors: function () { return {} }
        }
    },
    watch: {
        'user': function (user) {
            if (this.$route.params.id) {
                return
            }
            this.fillUser(user)
        }
    },
    methods: {
        fillUser (user) {
            this.first_name = user.first_name
            this.last_name = user.last_name
            this.email = user.email
            this.role_id = (user.role) ? user.role.id : null
            this.role_uuid = (user.role) ? user.role.uuid : null

            if (!user.role) {
                return
            }

            user.role.permissions.map(perm => {
                this.selectedPerms.push(perm.id)
            })
        },
        updateUser () {
            this.submitting = 'user'
            let data = {
                first_name: this.first_name,
                last_name: this.last_name,
                id: this.user.uuid
            }

            this.$store.dispatch('user/update', {data})
                .then(user => {
                    this.submitting = null
                })
        },
        updateAddress () {
            this.submitting = 'billing_address'
            let data = this.billing
            data.id = this.user.uuid

            this.$store.dispatch('user/updateAddress', {data})
                .then(res => {
                    this.submitting = null
                })
        },
        updatePassword () {
            this.submitting = 'password'
            let data = {
                password: this.password,
                password_confirm: this.password_confirm,
                id: this.user.uuid
            }

            this.$store.dispatch('user/updatePassword', {data})
                .then(res => {
                    this.submitting = null
                })
        },
    },
    computed: {
    },
    created () {
        this.fillUser(this.user)
    

        if (this.user && this.user.primary_address) {
            this.billing.street_1 = this.user.primary_address.street_1
            this.billing.street_2 = this.user.primary_address.street_2
            this.billing.city = this.user.primary_address.city
            this.billing.state = this.user.primary_address.state
            this.billing.country = this.user.primary_address.country
            this.billing.postal_code = this.user.primary_address.postal_code
            this.billing.phone = this.user.primary_address.phone
        }
    }
}
</script>



// WEBPACK FOOTER //
// prompts/views/pages/Profile.vue